module.exports = __webpack_public_path__ + "static/img/wei.d1d2c47a.png";